export const header = {
    target: '',
    kv: '',
    options: {
        root: null,
        rootMargin: '0px 0px',
        threshold: 0
    },
    init: ()=>{
        header.target = document.getElementById('header');
        header.kv = document.getElementById('kv');
        if(header.kv){
            const headerShow = new IntersectionObserver((entries)=>{
                for (const entry of entries){
                    if (!entry.isIntersecting) {
                        header.target.classList.add('show');
                      }else{
                        header.target.classList.remove('show');
                      }
                }
            }, header.options);
            headerShow.observe(header.kv);
        }else{
            header.target.classList.add('show');
        }
    }
}